import React from "react";
import { makeStyles } from "@material-ui/core";

import MobileHeader from "components/header/baseHeader/mobile/BaseTopHeader";
import { CATEGORY_TYPE_COMMERCIAL_CATEGORY, CATEGORY_TYPE_PRODUCT_TYPE } from "lib/constants";
import LeftPanel from "components/authentication/layout/LeftPanel";

export default function Layout({ categories, children }) {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <MobileHeader
        customBreakPoint="lgUp"
        productTypes={categories.filter((cat) => cat.type === CATEGORY_TYPE_PRODUCT_TYPE)}
        commercialCategories={categories.filter((cat) => cat.type === CATEGORY_TYPE_COMMERCIAL_CATEGORY)}
      />
      <LeftPanel />
      <div className={classes.formPanel}>{children}</div>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  formPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "70%",
    height: "100%",
    backgroundColor: "#F6F6F6",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));
